/* eslint-disable no-console,no-undef */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { getAmigoBirthday } from '../../redux/actions';
import { BirthdayCardUpdate, FeedCardWrapper,/* UserInitialsMain*/ } from "./styles";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
// import { ImageUrl } from '../../utils/constants';
// import { Divider } from "../Manager/styles";
// import { getInitials } from "../../utils/methods";
import moment from "moment";
import { BirthdayIcon } from "../../utils/icons";

class BirthdayWishCard extends Component {
  constructor(props) {
    super(props);
  }

  // componentDidMount(){
  //   const {getAmigoBirthday } = this.props;
  //   getAmigoBirthday();
  // }

  containsDefaultPng = (str) => {
    const defaultPngFound = str?.includes("default.png");
    return defaultPngFound;
  }


  render() {
    const { callback, amigoBirthdayList } = this.props;
    let birthday = []
    if(amigoBirthdayList?.today_birthday){
      birthday=[ ...amigoBirthdayList.today_birthday, ...amigoBirthdayList.recent_birthday, ...amigoBirthdayList.upcoming_birthday];
    }



    return (
      <>
        {birthday.length > 0 ? <FeedCardWrapper style={{background:"#F2F5FB", border:"0.75px solid #B9C8E8", borderRadius:"12px",position:"relative"}} margin="20px" height="160px" padding="0px 16px">
          <div className='heading'>
            <div className='title-updated'>Birthdays</div>
          </div>
          <div className="wishCountText"><span className="count">{birthday?.length}</span> {birthday?.length > 1 ? "Birthdays" : "Birthday"} In {moment().format("MMMM")}</div>
          {/* <Divider isMargin={'8px 16px 12px 16px'}></Divider> */}
          <div className='wrapper'>
            <BirthdayCardUpdate isWidth={"80px"} isHeight={"80px"}> 
              {/* <div className="images">
                {birthday?.slice(0,3)?.map((data,index)=>(
                  index==0?
                    <div className="image" key={index}>
                      {!this.containsDefaultPng(data.profile_image)?
                        <img src={ImageUrl + "/" +data.profile_image}/>:
                        <UserInitialsMain border isWidth={"80px"} isHeight={"80px"} size={"24px"} isBg color="#184A61" >{`${getInitials(data?.name)}`}</UserInitialsMain>}
                    </div>:
                    <div className="imageLeft" key={index}>
                      {!this.containsDefaultPng(data.profile_image)?
                        <img src={ImageUrl + "/" +data.profile_image}/>:
                        <UserInitialsMain border isWidth={"80px"} isHeight={"80px"} size={"24px"} isBg color="#184A61">{`${getInitials(data?.name)}`}</UserInitialsMain>}
                    </div>
                ))}
              </div> */}
              <div className="button" id="birthday-wishes" onClick={() => callback()}>Share Wishes</div>
              <div className="icon-wrapper">{BirthdayIcon()}</div>
            </BirthdayCardUpdate>
          </div>
        </FeedCardWrapper> : null}
      </>
    );
  }
}

BirthdayWishCard.propTypes = {
  birthdayList: PropTypes.array,
  history: PropTypes.object,
  t: PropTypes.func,
  callback: PropTypes.func,
  amigoBirthdayList:PropTypes.object,
  getAmigoBirthday:PropTypes.func,
};
const mapStateToProps = (state) => ({
  birthdayList: state.profileData.birthdayList,
  amigoBirthdayList: state.social.birthdayList,
})
const mapDispatchToProps = (dispatch) => ({
  getAmigoBirthday: () => dispatch(getAmigoBirthday()),
})
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(BirthdayWishCard));
